import { SuggestionResult } from 'core/type/SuggestionResult.types';

const suggestionList: SuggestionResult[] = [
    {
        activityId: 0,
        activityName: undefined,
        activityNameTranslated: undefined,
        addressId: undefined,
        cityAbbr: 'city',
        latitude: 13.750057,
        longitude: 100.49881,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: true,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'Bangkok',
            geoHierarchyName: 'Thailand',
            categoryName: 'City',
        },
        id: 9395,
        name: 'Bangkok',
        nameTranslated: 'Bangkok',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 9395,
        cityName: 'Bangkok',
        cityNameTranslated: 'Bangkok',
        countryId: 106,
        countryISO2: 'TH',
        countryName: 'Thailand',
        countryNameTranslated: 'Thailand',
        stateId: 2028,
        stateName: 'Bangkok Province',
        stateNameTranslated: 'Bangkok',
        placeType: 0,
        type: 2,
        url: '/city/thailand/bangkok',
        topCategories: [
            {
                id: 2,
                code: 'FOOD_AND_DRINKS',
            },
            {
                id: 7,
                code: 'TRANSPORTATION',
            },
            {
                id: 13,
                code: 'EXPERIENCES',
            },
        ],
    },
    {
        activityId: 0,
        activityName: undefined,
        activityNameTranslated: undefined,
        addressId: undefined,
        cityAbbr: 'city',
        latitude: 53.2241,
        longitude: -4.13567,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: false,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'Bangor',
            geoHierarchyName: 'United Kingdom',
            categoryName: 'City',
        },
        id: 103232,
        name: 'Bangor',
        nameTranslated: 'Bangor',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 103232,
        cityName: 'Bangor',
        cityNameTranslated: 'Bangor',
        countryId: 107,
        countryISO2: 'GB',
        countryName: 'United Kingdom',
        countryNameTranslated: 'United Kingdom',
        stateId: 3872,
        stateName: 'Wales County',
        stateNameTranslated: 'Wales',
        placeType: 0,
        type: 2,
        url: '/search?cityId=103232',
    },
    {
        activityId: 0,
        cityAbbr: 'city',
        latitude: 41.836188,
        longitude: 23.486023,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: false,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        objectTypeId: 0,
        displayNames: {
            name: 'Bansko',
            geoHierarchyName: 'Bulgaria',
            categoryName: 'City',
        },
        id: 18064,
        name: 'Bansko',
        nameTranslated: 'Bansko',
        areaId: 0,
        cityId: 18064,
        cityName: 'Bansko',
        cityNameTranslated: 'Bansko',
        countryId: 126,
        countryISO2: 'BG',
        countryName: 'Bulgaria',
        countryNameTranslated: 'Bulgaria',
        stateId: 2428,
        stateName: 'Blagoevgrad Province',
        stateNameTranslated: 'Blagoevgrad',
        placeType: 0,
        type: 2,
        url: '/search?cityId=18064',
    },
    {
        activityId: 0,
        activityName: undefined,
        activityNameTranslated: undefined,
        addressId: undefined,
        cityAbbr: 'city',
        latitude: 41.387917,
        longitude: 2.169919,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: true,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'Barcelona',
            geoHierarchyName: 'Spain',
            categoryName: 'City',
        },
        id: 2002,
        name: 'Barcelona',
        nameTranslated: 'Barcelona',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 2002,
        cityName: 'Barcelona',
        cityNameTranslated: 'Barcelona',
        countryId: 167,
        countryISO2: 'ES',
        countryName: 'Spain',
        countryNameTranslated: 'Spain',
        stateId: 2929,
        stateName: 'Catalonia Autonomous Community',
        stateNameTranslated: 'Catalonia',
        placeType: 0,
        type: 2,
        url: '/search?cityId=2002',
    },
    {
        activityId: 0,
        activityName: undefined,
        activityNameTranslated: undefined,
        addressId: undefined,
        cityAbbr: 'city',
        latitude: 30.0571,
        longitude: 31.2272,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: false,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'Cairo',
            geoHierarchyName: 'Egypt',
            categoryName: 'City',
        },
        id: 7923,
        name: 'Cairo',
        nameTranslated: 'Cairo',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 7923,
        cityName: 'Cairo',
        cityNameTranslated: 'Cairo',
        countryId: 16,
        countryISO2: 'EG',
        countryName: 'Egypt',
        countryNameTranslated: 'Egypt',
        stateId: 252,
        stateName: 'Al Jizah Governorate',
        stateNameTranslated: 'Al Jizah',
        placeType: 0,
        type: 2,
        url: '/search?cityId=7923',
    },
    {
        activityId: 0,
        activityName: undefined,
        activityNameTranslated: undefined,
        addressId: undefined,
        cityAbbr: 'city',
        latitude: 43.768491,
        longitude: 11.253262,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: true,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'Florence',
            geoHierarchyName: 'Italy',
            categoryName: 'City',
        },
        id: 16573,
        name: 'Florence',
        nameTranslated: 'Florence',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 16573,
        cityName: 'Florence',
        cityNameTranslated: 'Florence',
        countryId: 205,
        countryISO2: 'IT',
        countryName: 'Italy',
        countryNameTranslated: 'Italy',
        stateId: 3356,
        stateName: 'Tuscany Region',
        stateNameTranslated: 'Tuscany',
        placeType: 0,
        type: 2,
        url: '/search?cityId=16573',
    },
    {
        activityId: 0,
        activityName: undefined,
        activityNameTranslated: undefined,
        addressId: undefined,
        cityAbbr: 'city',
        latitude: 51.518144,
        longitude: -0.122223,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: true,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'London',
            geoHierarchyName: 'United Kingdom',
            categoryName: 'City',
        },
        id: 233,
        name: 'London',
        nameTranslated: 'London',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 233,
        cityName: 'London',
        cityNameTranslated: 'London',
        countryId: 107,
        countryISO2: 'GB',
        countryName: 'United Kingdom',
        countryNameTranslated: 'United Kingdom',
        stateId: 3865,
        stateName: 'London,\u00A0England County',
        stateNameTranslated: 'London,\u00A0England',
        placeType: 0,
        type: 2,
        url: '/city/united_kingdom/london',
    },
    {
        activityId: 0,
        activityName: undefined,
        activityNameTranslated: undefined,
        addressId: undefined,
        cityAbbr: 'city',
        latitude: 34.060502,
        longitude: -118.239733,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: true,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'Los Angeles (CA)',
            geoHierarchyName: 'United States',
            categoryName: 'City',
        },
        id: 12772,
        name: 'Los Angeles (CA)',
        nameTranslated: 'Los Angeles (CA)',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 12772,
        cityName: 'Los Angeles (CA)',
        cityNameTranslated: 'Los Angeles (CA)',
        countryId: 181,
        countryISO2: 'US',
        countryName: 'United States',
        countryNameTranslated: 'United States',
        stateId: 18,
        stateName: 'California State',
        stateNameTranslated: 'California',
        placeType: 0,
        type: 2,
        url: '/search?cityId=12772',
    },
    {
        activityId: 0,
        activityName: undefined,
        activityNameTranslated: undefined,
        addressId: undefined,
        cityAbbr: 'city',
        latitude: 19.42705,
        longitude: -99.127571,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: false,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'Mexico City',
            geoHierarchyName: 'Mexico',
            categoryName: 'City',
        },
        id: 2086,
        name: 'Mexico City',
        nameTranslated: 'Mexico City',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 2086,
        cityName: 'Mexico City',
        cityNameTranslated: 'Mexico City',
        countryId: 86,
        countryISO2: 'MX',
        countryName: 'Mexico',
        countryNameTranslated: 'Mexico',
        stateId: 1833,
        stateName: 'Federal District State',
        stateNameTranslated: 'Federal District',
        placeType: 0,
        type: 2,
        url: '/search?cityId=2086',
    },
    {
        activityId: 0,
        activityName: undefined,
        activityNameTranslated: undefined,
        addressId: undefined,
        cityAbbr: 'city',
        latitude: 40.725548,
        longitude: -73.866577,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: true,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'New York (NY)',
            geoHierarchyName: 'United States',
            categoryName: 'City',
        },
        id: 318,
        name: 'New York (NY)',
        nameTranslated: 'New York (NY)',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 318,
        cityName: 'New York (NY)',
        cityNameTranslated: 'New York (NY)',
        countryId: 181,
        countryISO2: 'US',
        countryName: 'United States',
        countryNameTranslated: 'United States',
        stateId: 46,
        stateName: 'New York State',
        stateNameTranslated: 'New York',
        placeType: 0,
        type: 2,
        url: '/search?cityId=318',
    },
    {
        activityId: 0,
        activityName: undefined,
        activityNameTranslated: undefined,
        addressId: undefined,
        cityAbbr: 'city',
        latitude: 48.856667,
        longitude: 2.350987,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: true,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'Paris',
            geoHierarchyName: 'France',
            categoryName: 'City',
        },
        id: 15470,
        name: 'Paris',
        nameTranslated: 'Paris',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 15470,
        cityName: 'Paris',
        cityNameTranslated: 'Paris',
        countryId: 153,
        countryISO2: 'FR',
        countryName: 'France',
        countryNameTranslated: 'France',
        stateId: 2820,
        stateName: 'Ile-de-France Region',
        stateNameTranslated: 'Ile-de-France',
        placeType: 0,
        type: 2,
        url: '/search?cityId=15470',
    },
    {
        activityId: 0,
        activityName: undefined,
        activityNameTranslated: undefined,
        addressId: undefined,
        cityAbbr: 'city',
        latitude: 7.925954,
        longitude: 98.34034,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: true,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'Phuket',
            geoHierarchyName: 'Thailand',
            categoryName: 'City',
        },
        id: 16056,
        name: 'Phuket',
        nameTranslated: 'Phuket',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 16056,
        cityName: 'Phuket',
        cityNameTranslated: 'Phuket',
        countryId: 106,
        countryISO2: 'TH',
        countryName: 'Thailand',
        countryNameTranslated: 'Thailand',
        stateId: 2058,
        stateName: 'Phuket Province',
        stateNameTranslated: 'Phuket',
        placeType: 0,
        type: 2,
        url: '/search?cityId=16056',
    },
    {
        activityId: 0,
        activityName: undefined,
        activityNameTranslated: undefined,
        addressId: undefined,
        cityAbbr: 'city',
        latitude: 1.288725,
        longitude: 103.853931,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: true,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'Singapore',
            geoHierarchyName: 'Singapore',
            categoryName: 'City',
        },
        id: 4064,
        name: 'Singapore',
        nameTranslated: 'Singapore',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 4064,
        cityName: 'Singapore',
        cityNameTranslated: 'Singapore',
        countryId: 114,
        countryISO2: 'SG',
        countryName: 'Singapore',
        countryNameTranslated: 'Singapore',
        stateId: 3789,
        stateName: 'Singapore',
        stateNameTranslated: 'Singapore',
        placeType: 0,
        type: 2,
        url: '/city/singapore/singapore',
    },
    {
        activityId: 0,
        activityName: undefined,
        activityNameTranslated: undefined,
        addressId: undefined,
        cityAbbr: 'city',
        latitude: 35.679052,
        longitude: 139.768753,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: true,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'Tokyo',
            geoHierarchyName: 'Japan',
            categoryName: 'City',
        },
        id: 5085,
        name: 'Tokyo',
        nameTranslated: 'Tokyo',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 5085,
        cityName: 'Tokyo',
        cityNameTranslated: 'Tokyo',
        countryId: 3,
        countryISO2: 'JP',
        countryName: 'Japan',
        countryNameTranslated: 'Japan',
        stateId: 120,
        stateName: 'Tokyo Prefecture',
        stateNameTranslated: 'Tokyo',
        placeType: 0,
        type: 2,
        url: '/city/japan/tokyo',
    },
    {
        activityId: 0,
        activityName: undefined,
        activityNameTranslated: undefined,
        addressId: undefined,
        cityAbbr: 'city',
        latitude: 43.653714,
        longitude: -79.381027,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: false,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'Toronto (ON)',
            geoHierarchyName: 'Canada',
            categoryName: 'City',
        },
        id: 4495,
        name: 'Toronto (ON)',
        nameTranslated: 'Toronto (ON)',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 4495,
        cityName: 'Toronto (ON)',
        cityNameTranslated: 'Toronto (ON)',
        countryId: 100,
        countryISO2: 'CA',
        countryName: 'Canada',
        countryNameTranslated: 'Canada',
        stateId: 9,
        stateName: 'Ontario Province',
        stateNameTranslated: 'Ontario',
        placeType: 0,
        type: 2,
        url: '/search?cityId=4495',
    },
    {
        activityId: 1053222,
        activityName: 'Bangkok Golden Dome Cabaret Show Ticket | Thailand',
        activityNameTranslated: 'Bangkok Golden Dome Cabaret Show Ticket | Thailand',
        addressId: undefined,
        cityAbbr: 'BKK',
        latitude: 0,
        longitude: 0,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: false,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'Bangkok Golden Dome Cabaret Show Ticket | Thailand',
            geoHierarchyName: 'Bangkok, Thailand',
            categoryName: 'Activity',
        },
        id: 1053222,
        name: 'Bangkok Golden Dome Cabaret Show Ticket | Thailand',
        nameTranslated: 'Bangkok Golden Dome Cabaret Show Ticket | Thailand',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 9395,
        cityName: 'Bangkok',
        cityNameTranslated: 'Bangkok',
        countryId: 106,
        countryISO2: 'TH',
        countryName: 'Thailand',
        countryNameTranslated: 'Thailand',
        stateId: 2028,
        stateName: 'Bangkok Province',
        stateNameTranslated: 'Bangkok',
        placeType: 0,
        type: 1,
        url: '/search?cityId=9395&selectedActivity=1053222',
    },
    {
        activityId: 1040866,
        activityName: 'Baiyoke Sky Hotel Buffet on 76th \u0026 78th Floor with Bangkok Sky Restaurant | Bangkok',
        activityNameTranslated: 'Baiyoke Sky Hotel Buffet on 76th \u0026 78th Floor with Bangkok Sky Restaurant | Bangkok',
        addressId: undefined,
        cityAbbr: 'BKK',
        latitude: 0,
        longitude: 0,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: false,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'Baiyoke Sky Hotel Buffet on 76th \u0026 78th Floor with Bangkok Sky Restaurant | Bangkok',
            geoHierarchyName: 'Bangkok, Thailand',
            categoryName: 'Activity',
        },
        id: 1040866,
        name: 'Baiyoke Sky Hotel Buffet on 76th \u0026 78th Floor with Bangkok Sky Restaurant | Bangkok',
        nameTranslated: 'Baiyoke Sky Hotel Buffet on 76th \u0026 78th Floor with Bangkok Sky Restaurant | Bangkok',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 9395,
        cityName: 'Bangkok',
        cityNameTranslated: 'Bangkok',
        countryId: 106,
        countryISO2: 'TH',
        countryName: 'Thailand',
        countryNameTranslated: 'Thailand',
        stateId: 2028,
        stateName: 'Bangkok Province',
        stateNameTranslated: 'Bangkok',
        placeType: 0,
        type: 1,
        url: '/search?cityId=9395&selectedActivity=1040866',
        categories: [
            {
                id: 2,
                code: 'FOOD_AND_DRINKS',
            },
        ],
    },
    {
        activityId: 1044657,
        activityName: 'Bangkok Private Tour: Damnoen Saduak Floating Market & Maeklong Railway Market | Thailand',
        activityNameTranslated: 'Bangkok Private Tour: Damnoen Saduak Floating Market & Maeklong Railway Market | Thailand',
        cityAbbr: 'BKK',
        latitude: 0,
        longitude: 0,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: false,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        objectTypeId: 0,
        displayNames: {
            name: 'Bangkok Private Tour: Damnoen Saduak Floating Market & Maeklong Railway Market | Thailand',
            geoHierarchyName: 'Bangkok, Thailand',
            categoryName: 'Activity',
        },
        id: 1044657,
        name: 'Bangkok Private Tour: Damnoen Saduak Floating Market & Maeklong Railway Market | Thailand',
        nameTranslated: 'Bangkok Private Tour: Damnoen Saduak Floating Market & Maeklong Railway Market | Thailand',
        areaId: 0,
        cityId: 9395,
        cityName: 'Bangkok',
        cityNameTranslated: 'Bangkok',
        countryId: 106,
        countryISO2: 'TH',
        countryName: 'Thailand',
        countryNameTranslated: 'Thailand',
        stateId: 2028,
        stateName: 'Bangkok Province',
        stateNameTranslated: 'Bangkok',
        placeType: 0,
        type: 1,
        url: '/search?cityId=9395&selectedActivity=1044657',
    },
    {
        activityId: 1044100,
        activityName: 'Singapore Night Safari Admission Ticket | Experience Night Safari, the world\u2019s first nocturnal park',
        activityNameTranslated: 'Singapore Night Safari Admission Ticket | Experience Night Safari, the world\u2019s first nocturnal park',
        addressId: undefined,
        cityAbbr: 'SG',
        latitude: 0,
        longitude: 0,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: false,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'Singapore Night Safari Admission Ticket | Experience Night Safari, the world\u2019s first nocturnal park',
            geoHierarchyName: 'Singapore, Singapore',
            categoryName: 'Activity',
        },
        id: 1044100,
        name: 'Singapore Night Safari Admission Ticket | Experience Night Safari, the world\u2019s first nocturnal park',
        nameTranslated: 'Singapore Night Safari Admission Ticket | Experience Night Safari, the world\u2019s first nocturnal park',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 4064,
        cityName: 'Singapore',
        cityNameTranslated: 'Singapore',
        countryId: 114,
        countryISO2: 'SG',
        countryName: 'Singapore',
        countryNameTranslated: 'Singapore',
        stateId: 3789,
        stateName: 'Singapore',
        stateNameTranslated: 'Singapore',
        placeType: 0,
        type: 1,
        url: '/search?cityId=4064&selectedActivity=1044100',
    },
    {
        activityId: 1067916,
        activityName: 'Singapore Singtel 5G/4G SIM Card | Airport/City pick up | Option with EZ-Link',
        activityNameTranslated: 'Singapore Singtel 5G/4G SIM Card | Airport/City pick up | Option with EZ-Link',
        addressId: undefined,
        cityAbbr: 'SG',
        latitude: 0,
        longitude: 0,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: false,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'Singapore Singtel 5G/4G SIM Card | Airport/City pick up | Option with EZ-Link',
            geoHierarchyName: 'Singapore, Singapore',
            categoryName: 'Activity',
        },
        id: 1067916,
        name: 'Singapore Singtel 5G/4G SIM Card | Airport/City pick up | Option with EZ-Link',
        nameTranslated: 'Singapore Singtel 5G/4G SIM Card | Airport/City pick up | Option with EZ-Link',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 4064,
        cityName: 'Singapore',
        cityNameTranslated: 'Singapore',
        countryId: 114,
        countryISO2: 'SG',
        countryName: 'Singapore',
        countryNameTranslated: 'Singapore',
        stateId: 3789,
        stateName: 'Singapore',
        stateNameTranslated: 'Singapore',
        placeType: 0,
        type: 1,
        url: '/search?cityId=4064&selectedActivity=1067916',
    },
    {
        activityId: 1045208,
        activityName: 'Tokyo Japan\uFF5CSanrio Puroland Ticket\uFF5Ccan be use immediately',
        activityNameTranslated: 'Tokyo Japan\uFF5CSanrio Puroland Ticket\uFF5Ccan be use immediately',
        addressId: undefined,
        cityAbbr: 'TY',
        latitude: 0,
        longitude: 0,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: false,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'Tokyo Japan\uFF5CSanrio Puroland Ticket\uFF5Ccan be use immediately',
            geoHierarchyName: 'Tokyo, Japan',
            categoryName: 'Activity',
        },
        id: 1045208,
        name: 'Tokyo Japan\uFF5CSanrio Puroland Ticket\uFF5Ccan be use immediately',
        nameTranslated: 'Tokyo Japan\uFF5CSanrio Puroland Ticket\uFF5Ccan be use immediately',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 5085,
        cityName: 'Tokyo',
        cityNameTranslated: 'Tokyo',
        countryId: 3,
        countryISO2: 'JP',
        countryName: 'Japan',
        countryNameTranslated: 'Japan',
        stateId: 120,
        stateName: 'Tokyo Prefecture',
        stateNameTranslated: 'Tokyo',
        placeType: 0,
        type: 1,
        url: '/search?cityId=5085&selectedActivity=1045208',
    },
    {
        activityId: 1033604,
        activityName: 'Sampan Boat Ride at Marina Bay Sands | Singapore',
        activityNameTranslated: 'Sampan Boat Ride at Marina Bay Sands | Singapore',
        addressId: undefined,
        cityAbbr: 'SG',
        latitude: 0,
        longitude: 0,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: false,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'Sampan Boat Ride at Marina Bay Sands | Singapore',
            geoHierarchyName: 'Singapore, Singapore',
            categoryName: 'Activity',
        },
        id: 1033604,
        name: 'Sampan Boat Ride at Marina Bay Sands | Singapore',
        nameTranslated: 'Sampan Boat Ride at Marina Bay Sands | Singapore',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 4064,
        cityName: 'Singapore',
        cityNameTranslated: 'Singapore',
        countryId: 114,
        countryISO2: 'SG',
        countryName: 'Singapore',
        countryNameTranslated: 'Singapore',
        stateId: 3789,
        stateName: 'Singapore',
        stateNameTranslated: 'Singapore',
        placeType: 0,
        type: 1,
        url: '/search?cityId=4064\u0026selectedActivity=1033604',
        categories: [
            {
                id: 7,
                code: 'TRANSPORTATION',
            },
            {
                id: 13,
                code: 'EXPERIENCES',
            },
        ],
    },
];

export default suggestionList;
